import SlideToggle from "../typescript/modules/slide-toggle";
import AddToBasketOverlay from "../typescript/modules/add-to-basket-overlay";
import Ecommerce from "../typescript/modules/ecommerce";

(<any>window).slideToggle = new SlideToggle();

(<any>window).AddToBasketOverlay = AddToBasketOverlay;

(<any>window).Ecommerce = Ecommerce;
const ecommerceElements = document.querySelectorAll('button.addToBasket');
for (let i = 0; i < ecommerceElements.length; i++) {
	new Ecommerce(ecommerceElements[i] as HTMLElement);
}
